import { render, staticRenderFns } from "./submitOrder.vue?vue&type=template&id=cde4064c&scoped=true&"
import script from "./submitOrder.vue?vue&type=script&lang=js&"
export * from "./submitOrder.vue?vue&type=script&lang=js&"
import style0 from "./submitOrder.vue?vue&type=style&index=0&id=cde4064c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde4064c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cde4064c')) {
      api.createRecord('cde4064c', component.options)
    } else {
      api.reload('cde4064c', component.options)
    }
    module.hot.accept("./submitOrder.vue?vue&type=template&id=cde4064c&scoped=true&", function () {
      api.rerender('cde4064c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cate/submitOrder.vue"
export default component.exports